import Vue from 'PublicJs/vue-bootstrap';
import ProfileArticlesTeaser from '../../Components/Profiles/ProfileArticlesTeaser';

new Vue({
	el: '#profiles-view',
	components: {
		ProfileArticlesTeaser
	}
});
